import { render, staticRenderFns } from "./Mentionable_extended.vue?vue&type=template&id=16667e46&"
import script from "./Mentionable_extended.vue?vue&type=script&lang=js&"
export * from "./Mentionable_extended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports